import React, { useEffect } from "react";
import SmtpTestForm from "components/SmtpComponent/SmtpTestForm";
import Header from "components/common/Header";

const Login = () => {
  useEffect(() => {
    document.title = " Login"; // Update the title when Login component mounts
  }, []);

  return (
    <div id="site_wrapper">
      <Header />
      <section className="login_wrapper">
        <SmtpTestForm />
      </section>
    </div>
  );
};

export default Login;
